import React, { ComponentProps } from 'react';
import { TableContainer as CarbonTableContainer } from '@carbon/react';

export type TableContainerProps = ComponentProps<typeof CarbonTableContainer>;

export const TableContainer = ({ children, ...props }: TableContainerProps) => (
  <CarbonTableContainer {...props}>{children}</CarbonTableContainer>
);

TableContainer.displayName = 'TableContainer';
